export const GROUP_ROLES = {
  SUPER_ADMIN: "group_super_admin",
  ADMIN: "group_admin",
  COLLABORATOR: "group_collaborator",
  NO_PERMISSIONS: "no_permissions",
};

export const normalizeGroupRole = (role) => {
  const normalized = (role || "").toLowerCase();
  if (Object.values(GROUP_ROLES).includes(normalized)) return normalized;
  if (normalized === "no permissions") return GROUP_ROLES.NO_PERMISSIONS;
  return GROUP_ROLES.COLLABORATOR;
};

export const hasMemberOrganisationAccess = (userData) => {
  const normalizedRole = (userData?.role || "").toLowerCase();

  if (["teacher", "school", "schooladmin"].includes(normalizedRole)) {
    return true;
  }

  return Boolean(userData?.schoolId?._id || userData?.schoolId || userData?.schoolName);
};

export const getOrganisationGroupRole = (userData) => {
  const groupData = userData?.organisationGroupId;
  const userId = userData?._id;
  const explicitRole =
    userData?.organisationGroupRole ||
    userData?.groupRole ||
    userData?.organisationRole;

  if (explicitRole) {
    return normalizeGroupRole(explicitRole);
  }

  if (groupData?.superAdminId && userId && groupData.superAdminId === userId) {
    return GROUP_ROLES.SUPER_ADMIN;
  }

  if (Array.isArray(groupData?.admins) && userId && groupData.admins.includes(userId)) {
    return GROUP_ROLES.ADMIN;
  }

  if (
    Array.isArray(groupData?.collaborators) &&
    userId &&
    groupData.collaborators.includes(userId)
  ) {
    return GROUP_ROLES.COLLABORATOR;
  }

  return GROUP_ROLES.COLLABORATOR;
};

export const formatOrganisationRole = (role) => {
  switch (normalizeGroupRole(role)) {
    case GROUP_ROLES.SUPER_ADMIN:
      return "Group Super Admin";
    case GROUP_ROLES.ADMIN:
      return "Group Admin";
    case GROUP_ROLES.NO_PERMISSIONS:
      return "No Permissions";
    default:
      return "Group Collaborator";
  }
};

export const getOrganisationRoleAccess = (userDataOrRole) => {
  const hasMemberAccess =
    typeof userDataOrRole === "string"
      ? false
      : hasMemberOrganisationAccess(userDataOrRole);
  const normalizedRole =
    typeof userDataOrRole === "string"
      ? normalizeGroupRole(userDataOrRole)
      : getOrganisationGroupRole(userDataOrRole);
  const isSuperAdmin = normalizedRole === GROUP_ROLES.SUPER_ADMIN;
  const isAdmin = normalizedRole === GROUP_ROLES.ADMIN;
  const isCollaborator = normalizedRole === GROUP_ROLES.COLLABORATOR;
  const hasNoPermissions = normalizedRole === GROUP_ROLES.NO_PERMISSIONS;

  return {
    role: normalizedRole,
    roleLabel: formatOrganisationRole(normalizedRole),
    isSuperAdmin,
    isAdmin,
    isCollaborator,
    hasNoPermissions,
    hasMemberAccess,
    canViewDashboard: !hasNoPermissions,
    canViewStaff: isSuperAdmin || isAdmin,
    canViewTeacherDetail: !hasNoPermissions,
    canViewMemberOrganisations: isSuperAdmin || isAdmin || isCollaborator,
    canInviteMemberOrganisation: isSuperAdmin || isAdmin,
    canEditPermissions: isSuperAdmin || isAdmin,
    canRemoveMemberOrganisation: isSuperAdmin,
    canManageAdminPermissions: isSuperAdmin,
    canViewSchoolDetails: hasMemberAccess,
  };
};
